import { gql } from "@apollo/client";

export const CREATE_ORDER = gql`
  mutation CreateOrderMutation($input: CreateOrderInput!) {
    createOrder(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_ORDER = gql`
  mutation UpdateOrderMutation($id: Int!, $input: UpdateOrderInput!) {
    updateOrder(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_ORDER = gql`
  mutation RemoveOrderMutation($id: Int!) {
    removeOrder(id: $id) {
      ok
      error
    }
  }
`;

export const ORDER = gql`
  query OrderQuery($id: Int!) {
    order(id: $id) {
      ok
      error
      result {
        id
        number
        status
        paymentStatus
        deliveryStatus
        totalHtCents
        totalTtcCents
        deliveryFeeCents
        deliveryFeeOrigin
        plannedDeliveryAt
        deliveredAt
        cancelReason
        externalInvoiceRef
        customer {
          id
          name
        }
        salesRep {
          id
          firstname
        }
        deliveryUser {
          id
          firstname
        }
        lines {
          id
          frozenLabel
          quantity
          unitPriceCents
          lineTotalCents
        }
      }
    }
  }
`;

export const ORDERS = gql`
  query OrdersQuery($where: OrdersFiltersInput!) {
    orders(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        number
        status
        paymentStatus
        deliveryStatus
        totalTtcCents
        plannedDeliveryAt
        customer {
          id
          name
        }
      }
    }
  }
`;
